import { render } from "./ProductBox.vue?vue&type=template&id=e7701910&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"

import "./ProductBox.vue?vue&type=style&index=0&id=e7701910&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e7701910"

export default script